var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtudes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.09 52.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.732,272.211l-2.135,2.355-8-8.065a9.657,9.657,0,0,1-8.046,2.146,9.316,9.316,0,0,1-5.842-3.538,9.632,9.632,0,1,1,15.979-1.134l8.04,8.133Z",
    transform: "translate(-384.645 -222.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.524,252.841a9.371,9.371,0,0,1-.085,1.12.988.988,0,0,1-1.017.852c-.121.007-.242.005-.363.005h-35.1a4.626,4.626,0,0,1-.518-.015,1.1,1.1,0,0,1-.961-.993c-.013-.154-.005-.31-.005-.466v-48.45c0-1.142.375-1.519,1.516-1.52h25.463c.013.224.036.422.036.619,0,3.33.032,6.661-.012,9.99a1.656,1.656,0,0,0,1.9,1.877c2.817-.016,5.633-.005,8.45-.005h.639v11.361a12.845,12.845,0,0,0-11.609,5.064,12.25,12.25,0,0,0-2.611,8.3A12.947,12.947,0,0,0,403.524,252.841ZM379.375,208.3q-3.342,0-6.686,0a1.631,1.631,0,0,0-1.853,1.833q-.005,5.873,0,11.747a1.676,1.676,0,0,0,1.876,1.88q6.66,0,13.32,0a1.677,1.677,0,0,0,1.882-1.878q.007-5.873,0-11.747a1.635,1.635,0,0,0-1.854-1.836Q382.717,208.3,379.375,208.3Zm-8.291,32.9H387v-3.219H371.083Zm16.14-11.936H371.09v3.189h16.133Zm.012,17.463H371.089V249.9h16.146Z",
    transform: "translate(-365.477 -203.374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.1,214.712V208.09l5.84,6.622Z",
    transform: "translate(-386.903 -205.331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.775,217.4v8.913H380.268V217.4Z",
    transform: "translate(-371.616 -209.196)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtudes);
export default __webpack_public_path__ + "static/media/icon-etudes.aa9343b0d4167fb964bdc3c0190ee89a.svg";
export { ForwardRef as ReactComponent };